import {
    Data
} from './utils.js';
import {
    DashArray
} from './style.js';

import {
    RGBA
} from './color.js';

class CanvasOutput {
    constructor(screen) {
        this.screen = screen;

    }

    static new(screen) {
        return new CanvasOutput(screen);
    }

    initFrame() {
        this.screen.clear();
    }

    finishFrame() {
        // noop
    }

    getWidth() {
        return this.screen.w();
    }
    getHeight() {
        return this.screen.h();
    }

    download(filename) {
        const a = document.createElement('a');
        a.href = this.screen.ctx().canvas.toDataURL();
        a.download = filename + '.png';
        a.click();
    }

    drawLineStrip(points, data) {
        data = data ? data : Data.new();
        if (points.length === 0) {
            return;
        }

        var ctx = this.screen.ctx();
        ctx.save();

        var strokeStyle = data.get('strokeStyle', RGBA.BLACK);
        ctx.strokeStyle = strokeStyle.toString();
        var linewidth = data.get('lineWidth', 1);
        ctx.lineWidth = linewidth;
        ctx.beginPath();

        ctx.moveTo(points[0][0], points[0][1]);
        for (let i = 1; i < points.length; i++) {
            let pi = points[i];
            ctx.lineTo(pi[0], pi[1]);
        }
        ctx.stroke();
        ctx.restore();
    }

    drawArc(p, r, alpha_min, alpha_max, data) {
        data = data ? data : Data.new();
        var ctx = this.screen.ctx();
        ctx.save();

        var strokeStyle = data.get('strokeStyle', RGBA.BLACK);
        var fillStyle = data.get('fillStyle', RGBA.WHITE);
        var dashArray = data.get('dashArray', DashArray.SOLID);

        if (strokeStyle.a() === 0 && fillStyle.a() === 0) {
            return;
        }
        var linewidth = data.get('lineWidth', 1);
        ctx.beginPath();
        ctx.arc(p[0], p[1], r, alpha_min, alpha_max);
        ctx.strokeStyle = strokeStyle.toString();
        ctx.fillStyle = fillStyle.toString();
        ctx.lineWidth = linewidth.toString();
        ctx.setLineDash(dashArray.dashes);
        ctx.stroke();
        ctx.fill();

        ctx.restore();

    }

    drawText(p, text, data) {
        data = data ? data : Data.new();
        var ctx = this.screen.ctx();
        var fillStyle = data.get('fillStyle', RGBA.WHITE);
        var strokeStyle = data.get('strokeStyle', RGBA.BLACK);

        var font = data.get('font', ctx.font);
        ctx.save();

        // manually reflip screen for text...
        const flipped = this.screen.flip();
        if (flipped) {
            this.screen.flip(false);
        }
        ctx.font = font;
        ctx.strokeStyle = strokeStyle.toString();
        ctx.fillStyle = fillStyle.toString();

        const h = this.getHeight();
        const y = flipped ? h - 1 - p[1] : p[1];
        ctx.fillText(text, p[0], y);
        ctx.strokeText(text, p[0], y);
        if (flipped) {
            this.screen.flip(flipped);
        }
        ctx.restore();

    }

    drawPoly(points, data) {
        data = data ? data : Data.new();
        var ctx = this.screen.ctx();
        ctx.save();
        ctx.lineCap = "round";
        var p = points;

        var fillStyle = data.get('fillStyle', RGBA.WHITE);
        var strokeStyle = data.get('strokeStyle', RGBA.BLACK);
        var lineWidth = data.get('lineWidth', 1);
        var dashArray = data.get('dashArray', DashArray.SOLID);
        ctx.fillStyle = fillStyle.toString();

        if (fillStyle.a() > 0) {
            // fill first
            ctx.beginPath();

            var p0 = p[0];
            ctx.moveTo(p0[0], p0[1]);
            for (let i = 1; i < p.length; i++) {
                let pi = p[i];
                //
                ctx.lineTo(pi[0], pi[1]);
            }
            ctx.closePath();
            ctx.fill();
            ctx.strokeStyle = fillStyle.toString();

            ctx.lineWidth = 0.5;
            if (fillStyle.a() === 1) {
                ctx.stroke();
            }
            // lines second
        }

        if (strokeStyle.a() > 0) {
            // normal lines
            ctx.lineWidth = lineWidth;
            ctx.setLineDash(dashArray.dashes);
            ctx.strokeStyle = strokeStyle.toString();
            ctx.beginPath();
            for (let i = 0; i < p.length; i++) {

                let idx = (i + 1) % p.length;
                let pi = p[idx];
                let pb = p[i];

                ctx.moveTo(pb[0], pb[1]);
                ctx.lineTo(pi[0], pi[1]);

            }
            ctx.stroke();
        }


        ctx.restore();
    }
}



class SVGOutput {
    constructor(w, h, flipy) {
        this.w = w;
        this.h = h;
        this.flipy = flipy !== undefined ? flipy : true;

        this.svg = "";
    }

    static new(w, h, flipy) {
        return new SVGOutput(w, h, flipy);
    }

    initFrame() {

        var doc = '<svg version="1.1" baseProfile="full" ';
        doc += 'width="' + this.w + '" ';
        doc += 'height="' + this.h + '" ';
        doc += 'shape-rendering="geometricPrecision" ';
        doc += 'xmlns="http://www.w3.org/2000/svg">\n';
        this.svg = doc;

    }

    y(py) {
        if (this.flipy) {
            return this.h - py;
        }
        else {
            return py;
        }
    }

    finishFrame() {
        this.svg += '</svg>';
    }

    getWidth() {
        return this.w;
    }

    getHeight() {
        return this.h;
    }

    download(filename) {

        var a = document.createElement('a');
        var blob = new Blob([this.svg], {
            'type': 'image/svg+xml'
        });
        a.href = window.URL.createObjectURL(blob);
        a.download = filename + '.svg';
        a.click();


    }

    drawText(p, text, data) {

        data = data ? data : Data.new();
        var options = data.get("svgOptions", {});
        var textEl = '<text ';
        var strokeStyle = data.get('strokeStyle', RGBA.BLACK);
        var fillStyle = data.get('fillStyle', RGBA.BLACK);
        var linewidth = data.get('lineWidth', 1);

        if (strokeStyle.a() === 0 && fillStyle.a() === 0) {
            return;
        }

        textEl += 'style="';
        textEl += strokeStyle.toSVG('stroke');
        textEl += fillStyle.toSVG('fill');
        textEl += '"';
        textEl += ' ';
        if (options.scalingStroke) {

            textEl += 'vector-effect="non-scaling-stroke" ';
        }
        textEl += 'stroke-width="' + linewidth + 'px"';
        textEl += ' ';
        textEl += ' ';


        textEl += 'x="' + p[0] + '" ';
        textEl += 'y="' + this.y(p[1]) + '" ';

        textEl += '>\n';
        textEl += text;
        textEl += '\n</text>';

        this.svg += textEl + '\n';
    }

    drawLineStrip = function (points, data) {

        if (points.length === 0) {
            return;
        }
        data = data ? data : Data.new();

        var line = '<polyline ';
        line += 'stroke-linecap="round" ';
        line += 'fill="none" ';

        var strokeStyle = data.get('strokeStyle', RGBA.BLACK);
        var linewidth = data.get('lineWidth', 1);
        var dashArray = data.get('dashArray', DashArray.SOLID);
        var attributes = data.get("attributes", {});

        if (strokeStyle.a() === 0) {
            return;
        }

        line += 'style="';
        line += strokeStyle.toSVG('stroke');
        line += '"';
        line += ' ';
        line += 'stroke-width="' + linewidth + 'px" ';
        line += dashArray.toSVG();
        line += ' ';
        for (let a in attributes) {
            line += a + '="';
            line += attributes[a];
            line += '" ';
        }

        line += 'points="';

        for (let i = 0; i < points.length; i++) {
            let pi = points[i];

            line += pi[0] + ',' + this.y(pi[1]) + ' ';
        }

        line += '"';
        line += '/>';

        this.svg += line + '\n';
    }

    drawArc(p, r, alpha_min, alpha_max, data) {

        data = data ? data : Data.new();
        var attributes = data.get("attributes", {});
        var circle = '<circle ';
        var strokeStyle = data.get('strokeStyle', RGBA.BLACK);
        var fillStyle = data.get('fillStyle', RGBA.WHITE);
        var dashArray = data.get('dashArray', DashArray.SOLID);
        if (strokeStyle.a() === 0 && fillStyle.a() === 0) {
            return '';
        }

        var linewidth = data.get('lineWidth', 1);

        circle += 'style="';
        circle += fillStyle.toSVG('fill');
        circle += strokeStyle.toSVG('stroke');
        circle += '"';
        circle += ' ';
        circle += 'stroke-width="' + linewidth + 'px"';
        circle += ' ';
        circle += dashArray.toSVG();
        circle += ' ';

        for (let a in attributes) {
            circle += a + '="';
            circle += attributes[a];
            circle += '" ';
        }

        circle += 'r="' + r + '"';
        circle += ' ';


        circle += 'cx="' + p[0] + '" ';
        circle += 'cy="' + this.y(p[1]) + '" ';

        circle += '/>';

        this.svg += circle + '\n';
    }

    drawPoly(points, data) {

        data = data ? data : Data.new();

        var fillStyle = data.get('fillStyle', RGBA.WHITE);
        var strokeStyle = data.get('strokeStyle', RGBA.BLACK);
        var dashArray = data.get('dashArray', DashArray.SOLID);
        var linewidth = data.get('lineWidth', 1);

        var attributes = data.get("attributes", {});
        if (fillStyle.a() === 0 && strokeStyle.a() === 0) {
            return;
        }

        var doc = '';
        var polyFill = '<polygon ';

        var pp = points;


        polyFill += 'style="';
        polyFill += fillStyle.toSVG('fill');
        polyFill += ' ';

        polyFill += strokeStyle.toSVG('stroke');
        polyFill += '"';

        polyFill += ' ';
        polyFill += 'shape-rendering="crispEdges"';
        polyFill += ' ';

        polyFill += ' ';
        polyFill += 'stroke-width="';
        polyFill += linewidth;
        polyFill += '"';
        polyFill += ' ';

        polyFill += dashArray.toSVG();
        polyFill += ' ';

        for (let a in attributes) {
            polyFill += a + '="';
            polyFill += attributes[a];
            polyFill += '" ';
        }

        polyFill += 'points="';



        for (let j = 0; j < pp.length; j++) {
            var point = pp[j];
            polyFill += point[0] + ',' + this.y(point[1]) + ' ';
        }
        polyFill += '"/>';
        doc += polyFill + "\n";

        this.svg += doc;

    }

    begin_group() {
        this.svg += '<g>\n';
    }

    end_group() {
        this.svg += '</g>\n';
    }
    add_svg(svg) {
        this.svg += svg;
        this.svg += '\n';
    }
}

export {
    CanvasOutput,
    SVGOutput
};
